import { Getter } from 'vuex'
import { RootState } from '@/store/types'
import { ProjectID } from '@/types/platform'
import { UserGetters, UserState } from '../types'

const getProjectAccessUserRoles: Getter<UserState, RootState> = (
  state,
  getters,
  rootState
) => {
  const getter: UserGetters['getProjectAccessUserRoles'] = (
    projectId: ProjectID = ProjectID[rootState.platform]
  ) => {
    if (projectId === ProjectID.im) {
      return state.current?.roles || []
    }

    return state.current?.projectAccessUsers[projectId]?.roles || []
  }

  return getter
}

export default getProjectAccessUserRoles
